import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api"
    : "/api");

const api = axios.create({
  baseURL,
  timeout: 30000, // Increased to 30 seconds for payment operations
});

export default api;